import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Dashboard from './components/Dashboard';
import Products from './components/Products';
import ProductPage from './components/ProductPage';
import { Cart } from './components/Cart';
import Checkout from './components/Checkout';
import DraftList from './components/DraftList';
import DraftDetail from './components/DraftDetail';
import DraftConvert from './components/DraftConvert';
import SharedDraft from './components/SharedDraft';
import OrderHistory from './components/OrderHistory';
import OrderDetail from './components/OrderDetail';
import PaymentCheckout from './components/PaymentCheckout';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentFailure from './components/PaymentFailure';
import SetTopBoxDemo from './components/SetTopBoxDemo';
import AnonymousCheckout from './components/AnonymousCheckout';
import AdminDashboard from './pages/AdminDashboard';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import './styles/theme.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <Routes>
          {/* Public auth routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Admin route */}
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/products"
            element={
              <PrivateRoute>
                <Products />
              </PrivateRoute>
            }
          />
          <Route
            path="/products/:productId"
            element={
              <PrivateRoute>
                <ProductPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/cart"
            element={
              <PrivateRoute>
                <Cart />
              </PrivateRoute>
            }
          />
          <Route
            path="/checkout"
            element={
              <PrivateRoute>
                <Checkout />
              </PrivateRoute>
            }
          />
          <Route
            path="/checkout/draft/:draftId"
            element={
              <PrivateRoute>
                <Checkout />
              </PrivateRoute>
            }
          />
          <Route
            path="/drafts"
            element={
              <PrivateRoute>
                <DraftList />
              </PrivateRoute>
            }
          />
          <Route
            path="/drafts/:quoteId"
            element={
              <PrivateRoute>
                <DraftDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/drafts/:quoteId/convert"
            element={
              <PrivateRoute>
                <DraftConvert />
              </PrivateRoute>
            }
          />
          {/* Public routes - no auth required */}
          <Route
            path="/drafts/shared/:token"
            element={<SharedDraft />}
          />
          <Route
            path="/checkout/anonymous"
            element={<AnonymousCheckout />}
          />
          <Route
            path="/orders"
            element={
              <PrivateRoute>
                <OrderHistory />
              </PrivateRoute>
            }
          />
          <Route
            path="/orders/:orderId"
            element={
              <PrivateRoute>
                <OrderDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/payment/checkout/:quoteId"
            element={
              <PrivateRoute>
                <PaymentCheckout />
              </PrivateRoute>
            }
          />
          <Route
            path="/payment/success"
            element={<PaymentSuccess />}
          />
          <Route
            path="/payment/failure"
            element={<PaymentFailure />}
          />
          <Route
            path="/demo/set-top-box"
            element={
              <PrivateRoute>
                <SetTopBoxDemo />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
